import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

function DistributionWarehouseBrandQuestionBubble() {
  return (
    <Tooltip
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            What distribution warehouse brand is this address?
          </T>
          <T size="xs" color="secondary">
            Make sure you enter the correct distribution warehouse brand, as it
            affects the quote, and helps us determine which carriers can
            correctly service this shipment.
          </T>
          <T size="xs" color="secondary">
            Incorrectly specifying this may lead to delays and additional
            charges
          </T>
        </Stack>
      }
    />
  );
}
export default DistributionWarehouseBrandQuestionBubble;
